'use client';

import { SvgIcon, SvgIconProps } from '../components';

export const GooglePlay = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M3.00873 1.73901C2.76103 1.99217 2.61768 2.38633 2.61768 2.89677V21.104C2.61768 21.6145 2.76103 22.0086 3.00873 22.2618L3.06986 22.3174L13.5197 12.1188V11.8779L3.06986 1.67932L3.00873 1.73901Z"
      fill="url(#paint0_linear_1150_16037)"
    />
    <path
      d="M16.9989 15.5205L13.5195 12.1193V11.8784L17.0032 8.47718L17.0812 8.52143L21.2067 10.8133C22.3841 11.4637 22.3841 12.534 21.2067 13.1885L17.0812 15.4763L16.9989 15.5205Z"
      fill="url(#paint1_linear_1150_16037)"
    />
    <path
      d="M17.0814 15.4756L13.5198 11.9981L3.00879 22.2616C3.39984 22.663 4.03754 22.7113 4.76272 22.31L17.0814 15.4756Z"
      fill="url(#paint2_linear_1150_16037)"
    />
    <path
      d="M17.0814 8.52064L4.76272 1.68622C4.0a3754 1.28898 3.39984 1.33735 3.00879 1.73871L13.5198 11.998L17.0814 8.52064Z"
      fill="url(#paint3_linear_1150_16037)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1150_16037"
        x1="12.5919"
        y1="21.2937"
        x2="-1.22112"
        y2="7.14615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.0066" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1150_16037"
        x1="22.7398"
        y1="11.9977"
        x2="2.33609"
        y2="11.9977"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1150_16037"
        x1="15.1447"
        y1="10.1078"
        x2="-3.58686"
        y2="-9.07741"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1150_16037"
        x1="0.362961"
        y1="28.319"
        x2="8.72743"
        y2="19.752"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
